import { Center, Text } from '@mantine/core';
import { IconZoomCheck } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales';

export const ActivitiesNoResults = () => {
  const { t } = useTranslation();

  return (
    <Center my={100} style={{ flexDirection: 'column' }}>
      <IconZoomCheck size={100} />
      <Text mt={25} fz="xl">
        {t(tKeys.CLIENT.ACTIVITIES.NO_RESULTS.TITLE)}
      </Text>
      <Text mt="sm" c="dimmed">
        {t(tKeys.CLIENT.ACTIVITIES.NO_RESULTS.DESCRIPTION)}
      </Text>
    </Center>
  );
};
